/**
 * A class to create a TimingMarker instance to track time
 */ import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
export var TimingMarker = /*#__PURE__*/ function() {
    "use strict";
    function TimingMarker(startMarker) {
        _class_call_check(this, TimingMarker);
        this._globalMarker = undefined;
        this._globalMarker = startMarker ? startMarker : performance.now();
    }
    _create_class(TimingMarker, [
        {
            key: "globalMarker",
            get: function get() {
                return this._globalMarker;
            }
        }
    ]);
    return TimingMarker;
}();
/**
 * A function to return a string value representing the time between end and start
 * or between time right now and start if end is undefined
 */ export var timingPairStringify = function(pair) {
    var _pair_end;
    var _pair_end_globalMarker;
    var end = (_pair_end_globalMarker = (_pair_end = pair.end) === null || _pair_end === void 0 ? void 0 : _pair_end.globalMarker) !== null && _pair_end_globalMarker !== void 0 ? _pair_end_globalMarker : new TimingMarker().globalMarker;
    var start = pair.start.globalMarker;
    if (start === undefined || end === undefined || start > end) {
        return undefined;
    }
    return (end - start).toString();
};
